module.exports = __webpack_public_path__ + "static/img/coo_thr_01.ea4c117.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/agent/coo_thr_01.png
// module id = BYU/
// module chunks = 6